import { render, staticRenderFns } from "./AddManufacturer.vue?vue&type=template&id=383d6ada&"
import script from "./AddManufacturer.vue?vue&type=script&lang=js&"
export * from "./AddManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports